<template>
  <div style="position: relative" v-click-outside="close">
    <template v-if="services.length === 0">-</template>

    <span v-else class="label-services">
      <span class="nowrap">{{ visibleServices.join(', ') }}</span>

      <span v-if="services.length > limit" @click="show = true" class="ml-2 plus-icon nowrap">
        <PlusIcon size="1x"/>
        {{ services.length - limit }}
      </span>
    </span>

    <div class="modal-services" v-if="show">
      <span v-for="service in services" :key="service">
        {{ service }}<br>
      </span>
      <XIcon class="close" @click="close"/>
    </div>
  </div>
</template>

<script>
  import { PlusIcon, XIcon } from 'vue-feather-icons'
  import ClickOutside from 'vue-click-outside'

  export default {
    components: { PlusIcon, XIcon },
    computed: {
      visibleServices() {
        return this.services.slice(0, this.limit)
      }
    },
    data() {
      return {
        show: false
      }
    },
    directives: { ClickOutside },
    methods: {
      close() {
        this.show = false
      }
    },
    mounted() {
      this.popupItem = this.$el
    },
    name: 'ServicesCell',
    props: {
      services: { required: true, type: Array },
      limit: { type: Number, default: 2 }
    }
  }
</script>

<style scoped>
  .label-services {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .modal-services {
    position: absolute;
    background-color: white;
    white-space: nowrap;
    top: 0;
    right: 0;
    padding: 16px;
    z-index: 1;
    border-radius: 10px;
    box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.2);
    overflow: auto;
  }
  .modal-services .close {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }
  .plus-icon {
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    background: #ececec;
  }
  .plus-icon:hover {
    background: #c3c3c3;
  }
</style>
